<template>
    <div class="modal fade" id="reserva">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Reserva tu test drive</h4>
                </div>
                <div class="modal-body">
                    <b-alert v-model="ifSuccess" variant="success" dismissible>
                        Se envio correctamente!
                    </b-alert>
                    <form @submit.prevent="onTestDriveForm">
                        <h6 class="text-modal">
                            Diligencie la siguiente información para agendar tu
                            cita.
                        </h6>
                        <b-card>
                            <b-row>
                                <b-col md="3" class="text-center mb-2">
                                    <!-- Imagen principal del vehículo -->
                                    <img
                                        :src="
                                            'https://brokcars-assets.s3.us-east-2.amazonaws.com/' +
                                                fotosData.foto_principal
                                        "
                                        class="img-fluid"
                                        alt="image"
                                    />
                                </b-col>
                                <b-col md="9">
                                    <div>
                                        <h4 class="m-0">
                                            <i class="fa fa-car"></i>
                                            {{ vehiculoData.marca }}
                                            {{ vehiculoData.linea }}
                                        </h4>
                                        <h5 class="grey-text">
                                            {{ vehiculoData.modelo }} |
                                            {{
                                                vehiculoData.kilometraje
                                                    | formatNumber
                                            }}
                                            km
                                        </h5>
                                        <h5 class="text-red">
                                            ${{
                                                vehiculoData.precio_publicacion
                                                    | formatNumber
                                            }}
                                        </h5>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                        <div class="row">
                            <div class="col-md-12">
                                <b-row class="mt-2">
                                    <b-col>
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Nombre"
                                                v-model.trim="
                                                    $v.form.nombre.$model
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        $v.form.nombre.$error
                                                }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    v-if="
                                                        !$v.form.nombre
                                                            .$required
                                                    "
                                                    >Este campo es
                                                    requerido</span
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Apellido"
                                                v-model.trim="
                                                    $v.form.apellido.$model
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        $v.form.apellido.$error
                                                }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    v-if="
                                                        !$v.form.apellido
                                                            .$required
                                                    "
                                                    >Este campo es
                                                    requerido</span
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <div class="form-group">
                                            <input
                                                type="email"
                                                class="form-control"
                                                placeholder="Correo electrónico"
                                                v-model.trim="
                                                    $v.form.email.$model
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        $v.form.email.$error
                                                }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    v-if="
                                                        !$v.form.email.$required
                                                    "
                                                    >Este campo es
                                                    requerido</span
                                                >
                                                <br />
                                                <span
                                                    v-if="!$v.form.email.$email"
                                                    >Formato de correo
                                                    electrónico inválido</span
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Celular"
                                                maxlength="10"
                                                v-model.number.lazy="
                                                    $v.form.celular.$model
                                                "
                                                :class="{
                                                    'is-invalid':
                                                        $v.form.celular.$error
                                                }"
                                            />
                                            <div class="invalid-feedback">
                                                <span
                                                    v-if="
                                                        !$v.form.celular
                                                            .$required
                                                    "
                                                    >Este campo es
                                                    requerido</span
                                                >
                                                <br />
                                                <span
                                                    v-if="
                                                        !$v.form.celular
                                                            .$numeric
                                                    "
                                                    >Formato de teléfono
                                                    inválido</span
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value=""
                                        v-model="form.autorizacion_check"
                                    />
                                    <label class="form-check-label">
                                        Al reservar tu test drive estás
                                        aceptando nuestra
                                        <a
                                            href="https://redautos.com/politica_tratamiento_datos_personales"
                                            target="_blank"
                                        >
                                            Política de privacidad de datos
                                            personales
                                        </a>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <button
                                        :disabled="onLoadForm"
                                        class="btn btn-block"
                                        type="submit"
                                    >
                                        Reservar
                                        <clip-loader
                                            :class="{ 'd-none': !onLoadForm }"
                                            style="display: inline;margin-right: 10px;"
                                            color="#fff"
                                            size="15px"
                                        ></clip-loader>
                                        <span
                                            :class="{ 'd-none': onLoadForm }"
                                            class="angle_arrow"
                                        >
                                            <i
                                                class="fa fa-angle-right"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            onLoadForm: false,
            ifSuccess: false,
            form: {
                nombre: "",
                apellido: "",
                email: "",
                celular: "",
                autorizacion_check: true
            }
        };
    },
    validations: {
        form: {
            nombre: {
                required
            },
            apellido: {
                required
            },
            email: {
                required,
                email
            },
            celular: {
                required,
                numeric
            }
        }
    },
    computed: {
        vehiculoData() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .vehiculo;
        },
        fotosData() {
            return this.$store.state.fichaTecnica.vehiculo.fotos;
        },
        idReporte() {
            return this.$store.state.fichaTecnica.vehiculo.info_vehiculo
                .id_reporte;
        }
    },
    methods: {
        onTestDriveForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return (this.submitStatus = "False");
            } else {
                this.onLoadForm = true;
                var {
                    nombre,
                    apellido,
                    celular,
                    email,
                    autorizacion_check
                } = this.form;
                axios
                    .post("/ajax/test_drive_form", {
                        id_reporte: this.idReporte,
                        nombre: nombre,
                        apellido: apellido,
                        email: email,
                        celular: celular,
                        autorizacion_check: autorizacion_check
                    })
                    .then(response => {
                        $("#reserva").modal("hide");
                        this.$swal.fire({
                            icon: "success",
                            title: "Reserva tu test drive",
                            text:
                                "¡Para continuar con la reserva de cita para tu test drive, uno de nuestros asesores se comunicara con usted!",
                            confirmButtonColor: "#858796"
                        });
                        var parseRes = response.data;
                        this.onLoadForm = false;
                        this.ifSuccess = true;
                        this.resetForm();
                    });
            }
        },
        resetForm() {
            this.form = {
                nombre: "",
                apellido: "",
                email: "",
                celular: "",
                autorizacion_check: true
            };
        }
    }
};
</script>

<style lang="scss">
label.form-check-label {
    color: #4e4e4e;
    margin-bottom: 10px;
    text-align: justify;
}
</style>
